import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import * as Api from "../../../appApi/AppApi";

const TAG = "getTestDevices.js";

function* workerGetTestDevices(payload) {
  try {
    if (!payload.data) {
      throw new Error(
        "bot id is undefined: Payload=>" + JSON.stringify(payload)
      );
    }
    const response = yield call(
      Api.makeSecuredGetRequest,
      API_ENDPOINT.GET_TEST_DEVICES + payload.data
    );
    // console.log(
    //   TAG,
    //   "[worker get test devices:]" + JSON.stringify(response)
    // );
    yield put(memberAction.getTestDevicesSuccess(response));
  } catch (error) {
    console.error(TAG, "Error: while getting test devices: ", error.message);
    yield put(memberAction.getTestDevicesFailed(error.message));
  }
}

export const watchGetTestDevicesSaga = takeLatest(
  memberType.GET_TEST_DEVICES_REQUESTED,
  workerGetTestDevices
);